import React, { useState } from "react";
import { Combobox, Transition } from "@headlessui/react";
import { CheckIcon, ChevronUpDownIcon } from "@heroicons/react/20/solid";
import { Storefront } from "@mui/icons-material";

export function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export const StoreDropdown = ({ store = {}, storeList = [], editStoreAccess = true, handleStoreChange }) => {
  const [query, setQuery] = useState("");

  const filteredStores = query === "" ? storeList : storeList.filter((store) => {
    let searchString = `${store.intRitasStoreID} - ${store.vchStoreName} - ${store.vchStoreState}`;
    return searchString?.toLowerCase().includes(query?.toLowerCase());
  });

  const handleFocus = (event) => {
    event.target.select();
  };

  return (
    <div className="store-tour-selector">
      {editStoreAccess ?
        <Combobox as="div" value={store} onChange={handleStoreChange}>
          <div className="relative mt-1 ml-1">
            <div className="absolute inset-y-0 left-0 flex items-center px-2 focus:outline-none">
              <img src="../../assets/icons/store-icon-rounded.png" alt="store-icon" width={26} height={26} />
            </div>
            <Combobox.Button>
              <Combobox.Input
                className="w-full rounded-md font-medium border border-gray-300 bg-white py-2 px-10 shadow-sm focus:border-secondary focus:outline-none focus:ring-1 focus:ring-secondary sm:text-sm"
                onChange={(event) => setQuery(event.target.value)}
                placeholder="Select Store"
                autoComplete="off"
                displayValue={(store) => {
                  if (store?.intRitasStoreID === 0 || store?.intRitasStoreID) {
                    return `${store?.intRitasStoreID} - ${store?.vchStoreName} - ${store?.vchStoreState}`;
                  }
                }}
                // auto selects the input text when onClick and onFocus
                onClick={handleFocus}
                onFocus={handleFocus}
              />
            </Combobox.Button>
            <Combobox.Button className="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none">
              <ChevronUpDownIcon
                className="h-5 w-5 text-gray-400"
                aria-hidden="true"
              />
            </Combobox.Button>
            <Transition
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
              afterLeave={() => setQuery("")}
            >
              <Combobox.Options
                style={{ zIndex: 1000 }}
                className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
              >
                {filteredStores.length === 0 && query !== "" ? (
                  <div className="relative cursor-default select-none py-2 px-4 text-gray-700">
                    Nothing found.
                  </div>
                ) : (
                  filteredStores.map((store) => (
                    <Combobox.Option
                      key={store.intStoreID}
                      value={store}
                      className={({ active }) =>
                        classNames(
                          "relative cursor-default select-none py-2 pl-3 pr-9",
                          active
                            ? "bg-secondary text-white"
                            : "text-gray-900"
                        )
                      }
                    >
                      {({ active, selected }) => (
                        <>
                          <span
                            className={classNames(
                              "block truncate",
                              selected && "font-semibold"
                            )}
                          >
                            {`${store.intRitasStoreID} - ${store.vchStoreName} - ${store.vchStoreState}`}
                          </span>

                          {selected && (
                            <span
                              className={classNames(
                                "absolute inset-y-0 right-0 flex items-center pr-4",
                                active ? "text-white" : "text-secondary"
                              )}
                            >
                              <CheckIcon
                                className="h-5 w-5"
                                aria-hidden="true"
                              />
                            </span>
                          )}
                        </>
                      )}
                    </Combobox.Option>
                  ))
                )}
              </Combobox.Options>
            </Transition>
          </div>
        </Combobox>
        : (
          <div className="relative mt-2 p-1">
            <div className="absolute inset-y-0 left-0 flex items-center border-r py-1 border-gray-200 rounded-r-md px-2 focus:outline-none">
              <img src="../../assets/icons/store-icon-rounded.png" alt="store-icon" width={26} height={26} />
            </div>
            <span className="w-full rounded-md border py-2 border-gray-300 bg-white px-10 shadow-sm focus:border-secondary focus:outline-none focus:ring-1 focus:ring-secondary sm:text-sm">
              {store?.intRitasStoreID} - {store?.vchStoreName} -{" "}
              {store?.vchStoreState}
            </span>
          </div>
        )}
    </div>
  )
}